export function convertBlobUrlToBase64(url: string): Promise<string | undefined>{
  return fetch(url)
    .then(response => response.blob())
    .then(convertBlobToBase64);
}
export function convertBlobToBase64(blob: Blob): Promise<string | undefined> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      resolve(reader.result?.toString().split(',')[1]);
    };
    reader.readAsDataURL(blob);
  });
}
